export default __webpack_public_path__ + "static/media/transcendence.d71a16a2.png";